import {createActions} from 'client/framework';

export default createActions(null, ['COPY_TEMPLATE', 'RESET_STORE']);
